import React from 'react';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import { Link } from 'components/navigation/Link/Link';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import StandardAutoInsuranceOffer from 'components/Offers/StandardAutoInsuranceOffer/StandardAutoInsuranceOffer';
import Label from 'components/form/Label/Label';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';

const AutoInsuranceForNewAutoLoanModuleView = props => {
  return (
    <>
      <Disclaimer
        showPartnerText
        datatestid={'AutoInsuranceForNewAutoLoan'}
        className={'margb8 m-padlr8'}
      />
      <SectionContainer>
        {props.seenPixel}
        <Row>
          <Label
            typeHeader="h2"
            className="text-28 m-text-20 bold fontGray500 margB32 m-margB16"
          >
            {props.tileName}
          </Label>
          <StaticOfferContainer
            eventHandler={props.eventHandler}
            offerMetadataList={props.offers}
            pagePosition={props.moduleName}
            modulePosition={props.modulePosition}
            autoInsuranceTemplate={StandardAutoInsuranceOffer}
            {...props}
          />
        </Row>

        <Row className="m-text-center text-right bold">
          <Link
            onClickCallback={props.onLinkClick}
            link="See more auto insurance"
            to="/offers?vertical=AUTO_INSURANCE"
            disableAriaLabel
          >
            See more options
          </Link>
        </Row>
      </SectionContainer>
    </>
  );
};

export default AutoInsuranceForNewAutoLoanModuleView;
